import { takeLatest, ForkEffect } from 'redux-saga/effects';

import createStatusCounts from 'state/shared/createStatusCounts';

import { signUpStepsActions } from './signUpStepsSlice';
import {
  createAccountSaga,
  sendVerificationEmailSaga,
  verifyAccountSaga,
  setupPasswordSaga,
  accountDetailsSaga,
} from './signUpStepsSagas';

const {
  CREATE_ACCOUNT_REQUEST,
  SEND_VERIFICATION_EMAIL_REQUEST,
  VERIFY_ACCOUNT_REQUEST,
  SETUP_PASSWORD_REQUEST,
  ACCOUNT_DETAILS_REQUEST,
} = signUpStepsActions;

const statusCounts = createStatusCounts(signUpStepsActions);

export default function* signUpStepsSaga(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(CREATE_ACCOUNT_REQUEST, createAccountSaga, statusCounts);
  yield takeLatest(
    SEND_VERIFICATION_EMAIL_REQUEST,
    sendVerificationEmailSaga,
    statusCounts
  );
  yield takeLatest(VERIFY_ACCOUNT_REQUEST, verifyAccountSaga, statusCounts);
  yield takeLatest(SETUP_PASSWORD_REQUEST, setupPasswordSaga, statusCounts);
  yield takeLatest(ACCOUNT_DETAILS_REQUEST, accountDetailsSaga, statusCounts);
}
